import { AuthModuleStore } from "./AuthModule/store";
import { DashboardModuleStore } from "./DashboardModule/store";
import { ImportExportModuleStore } from "@/modules/DashboardModule/modules/ImportExportModule/store";
import { ExportModuleStore } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store";

export const AppModules = {
  AuthModuleStore,
  DashboardModuleStore,
  ImportExportModuleStore,
  ExportModuleStore
};
